import React, { Component } from 'react';
import { Layout, Button } from 'antd';

import Feed from "../Feed";
import FilterPanel from '../../components/Modules/FilterPanel';
import PageHeader from "../../components/Modules/PageHeader";
import AskForLogin from '../../components/Modules/AskForLogin';

import Events from "../../services/events";

import '../Feed/feed.less'

const { Content } = Layout;

export default class Subscriptions extends Component {
  state = {
    loading: true,
    visibleRegistration: false,
    visibleAuth: true,
    activeType: 'auth'
  };

  async componentDidMount() {
    this.setFilters()
  };

  setFilters() {
    Events.setFilter('events', 'channels');
    Events.setSort('time', 'desc')
  };

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  };

  setStateHandler = (obj) => {
    this.setState(obj)
  };

  render() {
    const { subscriptions, channels } = this.props;
    const { uid, userClaims } = this.props.user;
    const { userType } = userClaims;
    let filteredChannels = [];

    const subscriptionsKey = subscriptions && uid &&
      Object.keys(subscriptions).filter(key => key === uid);

    if (subscriptionsKey && subscriptionsKey.length !== 0) {
      const subscribedChannels = subscriptions[subscriptionsKey[0]];

      filteredChannels = subscribedChannels && channels && channels.filter(function(event){
        return this.indexOf(event.id) >= 0
      }, subscribedChannels);
    }

    const FeedList = (
      <Feed
        list={userType === 'Admin' ? channels : filteredChannels}
        addButtonCaption={"Add channel"}
        renderType={"channels"}
        location={this.props.location}
      />
    );

    let page = (
      <Layout className="page-wrapper">
         <Content>
          <PageHeader
            className="header"
            title="Subscriptions"
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  title="Channel search"
                  type="channel"
                  deviceType
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="Channel search"
            mobileTypeSearch="channel"
          />

          { FeedList }
        </Content>
      </Layout>
    );

    if (!this.props.user || !this.props.user.uid) {
      page = (
        <React.Fragment>
          <PageHeader
            className="header"
            title="Subscriptions"
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  title="Channel search"
                  type="channel"
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="Channel search"
            mobileTypeSearch="channel"
          />
          <div className="container">
            <AskForLogin
              page="Subscriptions"
            />
          </div>
        </React.Fragment>
      )
    }

    return page;
  };
};



// WEBPACK FOOTER //
// ./src/pages/Subscriptions/index.js